<template>
  <div class="page_settlementTask">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="系统表头" size="small">
              <el-input v-model="listQuery.sysName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>AI小杰</el-breadcrumb-item>
          <el-breadcrumb-item :to="{path:'/dict'}">增强学习</el-breadcrumb-item>
          <el-breadcrumb-item>新增学习详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small">导出</el-button>
          <!-- <el-button type="danger" size="small" @click="delHandel">删除</el-button> -->
          <el-button type="success" size="small" @click="addNewField">添加表头学习</el-button>
        </div>
        <div class="projectName">项目名称：{{ projectName }}</div>
        <!-- <div class="flex">
          <el-form label-width="120px">
            <el-form-item label="增强学习提示词:">
              <el-input type="textarea" v-model="prompt" :autosize="{ minRows: 4,maxRows:10}" style="width:600px"></el-input>
            </el-form-item>
          </el-form>
          <el-popover placement="bottom" title="" width="500" trigger="hover">
            <el-button type="text" size="small" @click="copy()">复制</el-button>
            <div v-html="tipTxt2" class="tipTxt"></div>
            <i class="el-icon-question cp elIcon" slot="reference"></i>
          </el-popover>
          <el-button type="success" size="small" style="height: 32px; margin-left: 15px;" @click="savePrompt">保存提示词</el-button>
        </div> -->
        <el-table :data="tableData" border class="doc_table" @selection-change="handleSelectionChange" :max-height="tableHeight - 100 > 340 ? tableHeight - 100 : 340" v-loading="loading" style="width:100%">
          <el-table-column key="mul" type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="sysName" label="系统表头" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="defaultValue" label="缺省值" min-width="120" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}> {{ row.defaultValue ? row.defaultValue : '无' }}</template>
          </el-table-column>
          <el-table-column prop="calcValueStr" label="等于" min-width="300" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="editHandel(row)">编辑</el-button>
                <el-popconfirm title="请确认是否删除" @confirm="delRow(row)" style="margin: 0 10px;">
                  <el-button type="text" slot="reference" size="small">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="listQuery.PageModel.Page" :page-size="listQuery.PageModel.Rows" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager,next,jumper" :total="totalCount"></el-pagination>
        </div>

        <div class="btnBox">
          <el-button @click="goBack">返 回</el-button>
        </div>
      </div>
    </div>

    <!-- 新增/编辑 -->
    <el-dialog :title="type=='add' ? '添加系统字段' : '编辑'" :visible.sync="editVisible" width="650px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="dictForm" :model="dictForm" class="" label-width="100px" size="small" v-if="editVisible">
        <el-form-item label="系统字段:">
          <el-select v-model="dictForm.sysName" size="small" placeholder="" filterable clearable style="width: 180px;">
            <el-option v-for="(r, i) in allList" :key="i" :value="r.sVal"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="缺省值:">
          <el-input v-model="dictForm.defaultValue" size="small" clearable style="width:180px"></el-input>
        </el-form-item>
        <el-form-item label="">
          <div v-for="(item, index) in dictForm.calcValueList" :key="index" class="ruleItem flex">
            <el-select v-model="item.calculationSymbol" size="small" placeholder="" style="width: 60px;margin-right: 10px;" v-if="index!=0">
              <el-option value="无"></el-option>
              <el-option value="+"></el-option>
              <el-option value="-"></el-option>
              <el-option label="×" value="*"></el-option>
              <el-option label="÷" value="/"></el-option>
            </el-select>

            <div style="margin-right: 10px;" v-if="index==0">=</div>

            <el-select v-model="item.type" size="small" placeholder="" filterable clearable style="width: 140px;margin-right: 10px;">
              <el-option label="系统字段" value="1"></el-option>
              <el-option label="指定表头位置" value="2"></el-option>
              <el-option label="指定内容表头" value="3"></el-option>
              <el-option label="固定值" value="4"></el-option>
            </el-select>
            <el-select v-model="item.val1" size="small" placeholder="" filterable clearable style="width: 140px;" v-if="item.type == 1">
              <el-option v-for="(r, i) in allList" :key="i" :value="r.sVal"></el-option>
            </el-select>
            <div v-if="item.type == 2" class="flex aic">
              <el-input v-model="item.val1" type="number" size="small" clearable style="width:60px;margin-left: 10px;"></el-input>
              <div style="margin: 0 5px;">行</div>
              <el-input v-model="item.val2" type="number" size="small" clearable style="width:60px;margin-left: 10px;"></el-input>
              <div style="margin: 0 5px;">列</div>
            </div>
            <div v-if="item.type == 3" class="flex aic">
              <el-input v-model="item.val1" size="small" clearable style="width:120px;"></el-input>
              <!-- <div style="margin: 0 5px;">列</div> -->
            </div>
            <el-input v-if="item.type == 4" v-model="item.val1" size="small" clearable style="width:140px;"></el-input>


            <i class="el-icon-delete icon02 cp" v-if="index != 0" @click="delRule(index)"></i>
            <div class="flex aic cp" style="margin-left:10px" @click="addRule" v-if="dictForm.calcValueList.length - 1 == index">
              <i class="el-icon-circle-plus icon01"></i>
              <el-button type="text" style="margin-left:5px">添加</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmEdit" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          PageModel: {
            Rows: 100,
            Page: 1,
            OrderInput: []
          },
          id: '',
          sysName: '',
        },
        isbtnLoading: false,
        KeyList: [],
        dictForm: {
          id: '',
          busiId: 30, //BusiId=20 入职登记字段匹配 BusiId=30 结算单字段匹配 BusiId=40 银行流水字段匹配
          msg: '',
          msg1: '',
          msg2: '',
          templateId: '',
          defaultValue: null
        },
        type: '',
        editVisible: false,
        activeName: '4',
        activeName2: '0',
        totalCount: 0,
        tableData: [],
        allList: [], //所有字段
        roletype: localStorage.loginRoletype,
        loading: false,
        multipleSelection: [],
        permissionLists: [],
        rules: {},
        ruleForm: {},
        projectName: '',
        prompt: '', //提示词
        promptid: '',
        tipTxt: '',
        tipTxt2: ''
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.listQuery.id = this.$route.query.id;
        this.projectName = this.$route.query.projectName;
        this.getList();
        this.GetAllList();
        // this.getTips();
      }
    },
    methods: {
      checkPermission,
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      //分页
      handleCurrentChange(val) {
        this.listQuery.PageModel.Page = Number(val)
        this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.PageModel.Page = 1
        this.listQuery.PageModel.Rows = Number(val)
        this.getList()
      },
      getTips() {
        let str = `?ProjectName=${this.projectName}`
        xz.ArdCurStatGetFun('GetProjectLearningTips', str).then(res => {
          if (res.status == 'ok') {
            this.promptid = res.data.id;
            this.prompt = res.data.msg;
            let str = `?id=24`
            xz.ArdCurStatGetFun('GetOpenRetPrompt', str).then(r => {
              if (r.status == 'ok') {
                this.tipTxt = r.data;
                this.tipTxt2 = r.data.replace(/\r\n\t?/g, '</br>');
                if(!this.prompt || this.prompt==null){
                  this.prompt = r.data;
                }
              } else {}
            })
          } else {
            // this.payCompList = [];
          }
        })
      },
      getList() {
        this.GetHeaderLearningDetailList();
      },
      GetHeaderLearningDetailList() {
        this.loading = true;
        xz.ArdCurStat(this.listQuery, 'GetHeaderLearningDetailList').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      GetAllList() {
        let str = `?input=null`
        xz.ArdCurStatGetFun('GetApplySalaryDetailSFieldsList', str).then(res => {
          if (res.status == 'ok') {
            this.allList = res.data;
          }
        })
      },
      changeTab() {
        if (this.activeName == '0') {
          this.$router.push({
            path: '/settlementTask'
          })
        } else if (this.activeName == '3') {
          this.$router.push({
            path: '/taskSet'
          })
        } else if (this.activeName == '5' || this.activeName == '6') {
          this.$router.push({
            path: '/ruleSet',
            query: {
              activeName: this.activeName
            }
          })
        }
      },
      changeTab2() {
        if (this.activeName2 == '0') {
          this.listQuery.BusiId = '结算单字段匹配';
          this.dictForm.busiId = 30;
          this.getList()
        } else if (this.activeName2 == '1') {
          this.listQuery.BusiId = '入职登记字段匹配';
          this.dictForm.busiId = 20;
          this.getList()
        }
      },
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //编辑
      editHandel(row) {
        this.dictForm = {
          id: row.id,
          parentId: this.listQuery.id,
          sysName: row.sysName,
          defaultValue: row.defaultValue,
          calcValueList: JSON.parse(row.calcValue)
        }
        this.isbtnLoading = false;
        this.type = 'edit';
        this.editVisible = true;
      },
      chengeType(val) {
        if (val == '计算公式') {
          this.ruleForm = {
            formula: {
              operator: '=',
              values: [{
                name: ''
              }],
            },
            rule: '计算公式',
            systemField: this.dictForm.msg
          }
        }
      },
      addNewField() {
        this.isbtnLoading = false;
        this.KeyList = [''];
        this.dictForm = {
          id: '',
          parentId: this.listQuery.id,
          sysName: '',
          defaultValue: null,
          calcValueList: [{
            type: "",
            val1: "",
            val2: "",
            calculationSymbol: "="
          }]
        }
        this.type = 'add';
        this.editVisible = true;
      },
      //新增匹配字段
      addItem() {
        this.KeyList.push('')
      },
      delItem(i) {
        this.KeyList.splice(i, 1)
      },
      //添加计算公式
      addRule() {
        let d = {
          type: "",
          val1: "",
          val2: "",
          calculationSymbol: ""
        }
        this.dictForm.calcValueList.push(d);
      },
      delRule(i) {
        this.dictForm.calcValueList.splice(i, 1)
      },
      delRow(row) {
        let d = {
          id: row.id,
          parentId: this.listQuery.id,
          sysName: row.sysName,
          isDeleted: true,
          defaultValue: row.defaultValue,
          calcValueList: JSON.parse(row.calcValue)
        }
        xz.ArdCurStat(d, 'AddUpdataDelHeaderLearningDetail').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.$message.success('删除成功');
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      confirmEdit() {
        this.isbtnLoading = true;
        xz.ArdCurStat(this.dictForm, 'AddUpdataDelHeaderLearningDetail').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isbtnLoading = false;
            this.$message.success('保存成功');
            this.editVisible = false;
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      delHandel() {
        if (this.multipleSelection.length > 0) {
          this.loading = true;
          let arr = [];
          this.multipleSelection.forEach((e, i) => {
            arr.push(e.id)
            if (i == this.multipleSelection.length - 1) {
              let d = {
                id: arr
              }
              xz.RPAdel(d, 'DeleteToget').then(res => {
                if (res.status == 'ok') {
                  this.getList();
                  this.loading = false;
                  this.$message.success('删除成功');
                } else {
                  this.loading = false;
                  this.$message.error(res.msg);
                }
              })
            }
          });
        } else {
          this.$message.warning('请至少选择一个任务')
        }
      },
      getVal(val) {
        let v = JSON.parse(val);
        // v.formula.values[0].name + 
        let str = ''
        v.formula.values.forEach((e, i) => {
          if (e.operation != undefined && e.operation) {
            str = str + e.operation
          }
          if (e.name != '固定值') {
            str = str + e.name
          } else {
            str = str + e.value
          }
        });
        return str
      },
      //返回
      goBack() {
        window.close()
      },
      savePrompt() {
        if (!this.prompt) {
          this.$message.warning('请填写提示语')
        } else {
          this.isbtnLoading = true;
          let d = {
            id: this.promptid,
            msg: this.prompt
          }
          xz.ArdCurStat(d, 'UpdataProjectLearningTips').then(res => {
            if (res.status == 'ok') {
              this.isbtnLoading = false;
              this.$message.success('保存成功');
            } else {
              this.isbtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        }
      },
      copy() {
        navigator.clipboard.writeText(this.tipTxt).then(() => {
          this.$message.success('复制成功')
        })
      },
      GetOpenRetPrompt() {
        let str = `?id=24`
        xz.ArdCurStatGetFun('GetOpenRetPrompt', str).then(res => {
          if (res.status == 'ok') {
            this.tipTxt = res.data;
            this.tipTxt2 = res.data.replace(/\r\n\t?/g, '</br>');
          } else {}
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .ruleItem {
    margin-top: 10px;
  }

  .icon01 {
    color: #19bd92;
    font-size: 20px;
    cursor: pointer;
  }

  .icon02 {
    // color: #19bd92;
    font-size: 20px;
    cursor: pointer;
    margin-left: 5px;
    line-height: 32px;
  }

  .btnBox {
    margin-top: 20px;
    width: 95%;
    display: flex;
    justify-content: center;
  }

  .projectName {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 600;
  }

  .elIcon {
    font-size: 24px;
    color: red;
    margin-left: 15px;
  }

  .tipTxt {
    max-height: 300px;
    overflow-y: scroll;
  }
</style>
<style>
  .page_settlementTask .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_settlementTask .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_settlementTask .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_settlementTask .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_settlementTask .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_settlementTask .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>